import { get } from 'svelte/store';

import { activityId, isLogin, userID } from '../store/index';

import { getCookie } from '@/utils/cookie';
import url from '@/utils/url';

const PREFIX = 'mx_msi_cc_reward_claim_';

export type RewardClaimPayload = {
    pageId: string;
    uid: string;
    activityId: string;
};

/** 与当前 URL pageId 绑定的 localStorage key */
export const rewardClaimStorageKey = (pageId: string) =>
    `${PREFIX}${encodeURIComponent(pageId)}`;

export function saveRewardClaim(payload: RewardClaimPayload): void {
    const { pageId, uid, activityId: aid } = payload;

    if (!pageId || !uid || !aid) return;

    try {
        // 统一落盘为字符串，避免 JSON 里 activityId 变成 number 导致读取时 typeof === 'string' 不匹配
        localStorage.setItem(
            rewardClaimStorageKey(pageId),
            JSON.stringify({ pageId, uid, activityId: String(aid) })
        );
    } catch {
        console.log('saveRewardClaim error');
    }
}

/**
 * cookie uid 与落盘 uid 一致、且 pageId 与当前 URL 一致时，返回已存的 activityId
 */
export function getMatchedRewardActivityId(): string | null {
    const pageId = url.get('pageId');
    // 某些环境（如 WebView / 埋点链路）可能出现 store 已登录但 cookie uid 仍为空的情况
    const uid = getCookie('uid') || get(userID);

    if (!pageId || !uid) return null;

    try {
        const raw = localStorage.getItem(rewardClaimStorageKey(pageId));

        if (!raw) return null;

        const data = JSON.parse(raw) as Partial<
            Omit<RewardClaimPayload, 'activityId'> & { activityId?: string | number }
        >;

        const aid =
            data.activityId === undefined || data.activityId === null
                ? ''
                : String(data.activityId);

        if (data.pageId === pageId && data.uid === uid && aid) {
            return aid;
        }

        return null;
    } catch {
        return null;
    }
}

/** 已登录且本地记录与当前 uid、pageId 关联命中时，同步 store（activityId + 领奖态） */
export function applyRewardClaimToStore(): void {
    if (!get(isLogin)) return;

    const aid = getMatchedRewardActivityId();

    if (!aid) return;

    activityId.set(aid);
}
